import styled from 'styled-components';

const Card = styled.div`
  background: ${({ theme }) => theme.colors.background.card};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: ${({ $padding }) => $padding || '16px'};
  box-shadow: ${({ theme }) => theme.shadow.small};
  border: 1px solid ${({ theme }) => theme.colors.border};
  margin-bottom: ${({ $mb }) => $mb || '0'};
`;

export default Card;
